<template>
  <div id="active">
    <div class="rightContent">
      <div class="tableheader">
        <el-button @click="editActive" class="btn3" type="primary" size="small">+ {{$t("active_add")}}</el-button>
        <div style="text-align:right;float:right">
          <el-date-picker
            size="small"
            style="top:2px;"
            @change="getList"
            v-model="dateValue"
            value-format="yyyy-MM-dd"
            type="daterange"
            :range-separator="$i18n.t('to')"
            :start-placeholder="$i18n.t('start_time')"
            :end-placeholder="$i18n.t('end_time')"
          ></el-date-picker>
          <el-select
            @change="getList"
            size="small"
            v-model="sForm.status"
            class="codeshearch"
            :placeholder="$i18n.t('award_status')"
          >
            <el-option
              :label="$i18n.t('award_waite_work')"
              key="opt1"
              value="-1"
            >{{$t("award_waite_work")}}</el-option>
            <el-option :label="$i18n.t('award_work')" key="opt2" value="10">{{$t("award_work")}}</el-option>
          </el-select>
          <el-input
            class="codeshearch"
            size="small"
            v-model="sForm.expect"
            :placeholder="$i18n.t('active_expect')"
          ></el-input>
          <el-input
            class="codeshearch"
            size="small"
            v-model="sForm.act_name"
            :placeholder="$i18n.t('active_name')"
          ></el-input>
          <el-button
            @click="getList"
            class="btn3"
            type="primary"
            size="small"
            style="margin-left:0.04rem;"
          >{{$t("search")}}</el-button>
        </div>
      </div>
      <div class="listBlock">
        <el-table :data="lists" style="width: 100%">
          <el-table-column prop="id" label="ID" width="80"></el-table-column>
          <el-table-column prop="act_name" :label="$i18n.t('active_name')"></el-table-column>
          <el-table-column :label="$i18n.t('active_time')">
            <template slot-scope="scope">
              <div style="font-size:0.01rem;">
                {{scope.row.start_time}} {{$t("to")}}
                <br />
                {{scope.row.end_time}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="act_desc" :label="$i18n.t('active_short')"></el-table-column>
          <el-table-column :label="$i18n.t('actives') + $i18n.t('award_status')">
            <template slot-scope="scope">
              <el-switch
                @change="statusActive(scope.row.id, scope.row.status)"
                v-model="scope.row.status"
                active-color="#57AEC9"
                inactive-color="#CCCCCC"
                :active-value="10"
                :inactive-value="0"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column :label="$i18n.t('contral')">
            <template slot-scope="scope">
              <el-button type="text" @click="editActive(scope.row)">{{$t("edit")}}</el-button>
              <el-button type="text" @click="statusActive(scope.row.id, -10)">{{$t("delete")}}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="margin: 10px auto;text-align: center;"
		  background
          v-show="showFlow"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          :page-sizes="[2]"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "active",
  data() {
    return {
      doing: false,
      doing1: false,
      lists: null,
      deviceLists: null,
      configType: '1',
      showFlow: false,
      pageSize: 2,
      page: 1,
      total: 100,
      now_result_id: "",
      dialogTableVisible: false,
      dateValue: "",
      adateValue: "",
      multipleSelection: [],
      dialogFormVisible: false,
      ids: [],
      sForm: {
        expect: "",
        act_name: "",
        status: ""
      },
      aForm: {
        expect: "",
        act_name: "",
        status: "",
        act_desc: "",
        start_time: "",
        end_time: "",
        act_bg: ""
      },
      formLabelWidth: "1rem"
    };
  },
  computed: {},
  created() {
    this.resizedwindow()
	this.getList()
  },
  methods: {
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      if (this.doing === true) {
        return false;
      }
      let dataLoadIng = this.openFullScreen();
      this.doing = true;
      let _this = this;
      let data = this.sForm;
      data.page = this.page;
      data.pageSize = this.pageSize;
      data.start_time = this.dateValue[0];
      data.end_time = this.dateValue[1];
      this.axios
        .post("/skinMgrSrv/active/list", this.formData(data))
        .then(function(response) {
          _this.doing = false;
          if (response.data.code === 0) {
            _this.total = parseInt(response.data.data.total);
            _this.showFlow = true;
            _this.lists = response.data.data.list;
          }
          setTimeout(() => {
            dataLoadIng.close();
          }, 500);
          console.log(response.data);
        });
    },
    editActive(data) {
      localStorage.editActiveData = "";
      if (data) {
        localStorage.editActiveData = JSON.stringify(data);
      }
      this.$router.push({ path: "/skinmgr/editActive" });
    },
    statusActive(id, status) {
      if (this.doing === true) {
        return false;
      }
      this.doing = true;
      let _this = this;
      let data = { id: id, status: status };
      this.axios
        .post("/skinMgrSrv/active/save", this.formData(data))
        .then(function(response) {
          _this.doing = false;
          if (response.data.code === 0) {
            _this.$message(_this.$i18n.t("support_success"));
            _this.getList();
          }
        })
    }
  }
};
</script>
<style  lang="scss">
#active {
  .tabs-container {
    .el-card__header {
      padding: 0.0833rem 0.1667rem !important;
    }
    .el-card {
      cursor: pointer;
    }
    .el-card:hover {
      border: $blue 1px solid;
    }
  }
  .el-input__inner {
    width: 2.5rem;
  }
  .codeshearch,
  .codeshearch .el-input__inner {
    width: 1.5rem;
  }
  .codeshearch {
    margin-left: 0.05rem;
    margin-right: 0.02rem;
  }
  .avatar-uploader,
  .el-upload,
  .el-upload--text {
    width: 1.22rem;
    height: 0.6rem;
    display: inline-block;
  }
  .avatar-uploader-icon {
    border: 1px solid #ccc;
  }
}
</style>
<style scoped lang="scss">
#active {
  box-sizing: border-box;
  .rightContent {
    width: calc(100% - 0.32rem);
    height: calc(100% - 0.1667rem);
    display: inline-block;
    background-color: #fff;
    margin-left: 0.1667rem;
    margin-top: 0.1667rem;
    border-radius: 0.05rem;
    .tableheader {
      margin: 0.16rem;
    }
    p.title {
      height: 0.4167rem;
      line-height: 0.4167rem;
      font-size: 0.15rem;
      color: #000;
    }
    .btn2,
    .btn3 {
      padding: 0.0667rem 0.0833rem;
      background-color: #57AEC9;
      border: 1px solid #57AEC9;
    }
    .listBlock {
      margin: 0.08rem;
    }
    .warncolor {
      color: red;
    }
    .btndel {
      margin-left: 0.1rem;
      height: 0.28rem;
      position: relative;
      top: 0.05rem;
    }
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 1.22rem;
    height: 0.5rem;
    margin-left: 1rem;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    color: #8c939d;
    width: 1.22rem;
    height: 1.22rem;
    text-align: center;
    line-height: 1.22rem;
    margin-top: 0.08rem;
  }
  .imgblockForLogo {
    width: 1.22rem;
    height: 1.22rem;
    display: inline-block;
    border: 1px solid #ccc;
    margin-top: 0.08rem;
  }
  .avatar {
    width: 1.22rem;
    height: 1.22rem;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/sell/lottory.vue